export const apiPaths = {
  admin: {
    discountCode: {
      exact: "/admin/discount-code",
      create: "/admin/discount-code/create",
      toggleActive: "/admin/discount-code/toggle-active",
      patients: "/admin/patients",
      store: "/admin/discount-code/store",
      searchServices: "/admin/discount-code/search-services",
    },
    patients: {
      exact: "/admin/patients",
      changeStatus: "/admin/patients/change-status",
    },
    invoices: {
      saveInvoice: "/admin/invoices/save-invoice",
      exact: "/admin/invoices",
      createdInvoices: "/admin/invoices/created-invoices",
      generateDownloadUrl: "/admin/invoices/generate-download-url",
    },
    doctors: {
      exact: "/admin/doctors",
      changeStatus: "/admin/doctors/change-status",
      store: "/admin/doctors/store",
      update: "/admin/doctors/update",
      edit: "/admin/doctors/edit",
      sendMessage: "/admin/doctors/send-message",
    },
    raports: {
      dailyRaportLinks: "/admin/raports/daily-raport-links",
    },
    referrals: {
      exact: "/admin/referrals",
      sportReferralsErrors: "/admin/referrals/sport-referrals-errors",
      stats: "/admin/referrals/stats",
      detailReferralError: "/admin/referrals/detail-referral-error",
    },
  },
  doctors: {
    services: {
      get: (doctorId?: number) => `/doctors/${doctorId}/services`,
    },
  },
  doctor: {
    meetings: {
      upcoming: {
        exact: "/doctor/meetings/upcoming",
      },
    },
    patients: {
      exact: "/doctor/patients",
      store: "/doctor/patients/store",
      update: "/doctor/patients/update",
      askForExamination: "/doctor/patients/ask-for-examination",
      meetings: "/doctor/patients/meetings",
      services: "/dictionary/meetings",
    },
    billingData: {
      update: "/doctor/billing-data/update",
      store: "/doctor/billing-data/store",
    },
    package: {
      show: "/doctor/package/show",
      store: "/doctor/package/store",
      update: "/doctor/package/update",
      service: {
        store: "/doctor/package/service/store",
      },
      delete: "/doctor/package/delete",
    },
    invoices: {
      exact: "/doctor/invoices",
    },
    stats: "/doctor/stats",
    services: {
      exact: "/doctor/services",
      store: "/doctor/services/store",
    },
    service: {
      exact: "/doctor/service",
      store: "/doctor/service/store",
    },
    specializations: {
      services: "/doctor/specializations/services",
    },
  },
  login: {
    exact: "/login",
  },
  logout: {
    exact: "/logout",
  },
  register: {
    exact: "/register",
    verify: "/register/verify",
    sendVerificationToken: "/register/send-verification-token",
    chooseFacility: "/register/choose-facility",
  },
  changeContext: {
    exact: "/change-context",
  },
  password: {
    email: "/password/email",
    reset: "/password/reset",
    update: "/password/update",
  },
  referrals: {
    exact: "/referrals",
    edit: "/referrals/edit",
    store: "/referrals/store",
    update: "/referrals/update",
    pay: "/referrals/pay",
    getExaminations: "/referrals/get-examinations",
    editFacility: "/referrals/edit-facility",
    updateFacility: "/referrals/update-facility",
    updatePatient: "/referrals/update-patient",
    checkResults: "/referrals/check-results",
    allReferrals: "/referrals/all-referrals",
    sendAndDownload: "/referrals/send-and-download",
    results: "/referrals/results",
    downloadResult: "/referrals/download-result",
    userInteraction: "/referrals/user-interaction",
    checkPhoneNumber: "/referrals/check-phone-number",
    resendSms: "/referrals/resend-sms",
    retryPayment: "/referrals/retry-payment",
  },
  updated: {
    examinationsData: "/updated/examinations-data",
  },
  keepers: {
    exact: "/keepers",
  },
  getFacilities: {
    exact: "/get-facilities",
  },
  features: {
    exact: "/features",
    enabled: "/features/enabled",
  },
  invoices: {
    download: "/invoices/download",
  },
  patientCsv: {
    exact: "/patient-csv",
  },
  download: {
    exact: "/download",
  },
  mainMedicalCategories: {
    exact: "/main-medical-categories",
  },
  user: {
    exact: "/user",
  },
  referralGroups: "/referralGroups",
  profile: {
    update: "/profile/update",
  },
  doctorAccountCreated: {
    verify: "/doctor-account-created/verify",
  },
  facilities: {
    cityHints: "/facilities/city-hints",
  },
  checkTransaction: "/check-transaction",
  isRegister: "/is-register",
  meet: {
    create: "/meet",
    activeOwner: "/meet/active/owner",
  },
  calendar: {
    exact: "/calendar",
    doctor: {
      day: {
        get: (doctorId: number, date: string) =>
          `/calendar/doctor/day/${doctorId}/${date}`,
      },
      week: {
        get: (doctorId: number, weekNo: number, year: number) =>
          `/calendar/doctor/week/${doctorId}/${weekNo}/${year}`,
      },
    },
    schedule: {
      open: {
        exact: "/calendar/schedule/open",
        clinic: {
          get: (clinicId: number, weekNo: number, year: number) =>
            `/calendar/schedule/open/${clinicId}/${weekNo}/${year}`,
          doctor: {
            get: (clinicId: number, doctorId: number) =>
              `/calendar/schedule/open/${clinicId}/${doctorId}`,
          },
        },
      },
      upcoming: {
        exact: "/calendar/schedule/upcoming",
      },
      changeFuture: {
        exact: "/calendar/schedule/change-future",
        check: "/calendar/schedule/change-future/check",
      },
    },
    clinic: {
      week: {
        get: (clinicId: number, weekNo: number, year: number) =>
          `/calendar/clinic/week/${clinicId}/${weekNo}/${year}`,
      },
      day: {
        get: (clinicId: number, dayDate: string) =>
          `/calendar/clinic/day/${clinicId}/${dayDate}`,
      },
    },
  },
  clinic: {
    exact: "/clinic",
    roles: "/clinic/roles",
    doctors: {
      exact: "/clinic/doctors",
    },
    patients: {
      exact: "/clinic/patients",
    },
    services: {
      exact: "/clinic/services",
      available: "/clinic/services/available",
    },
    medicalCategories: "/clinic/medical-categories",
    employees: {
      exact: "/clinic/employees",
    },
  },
  accountCompletion: {
    exact: "/account-completion",
  },
} as const;
